import { createTheme, responsiveFontSizes, Theme } from "@mui/material/styles";

let lightTheme: Theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#ff782d",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2A132E",
      contrastText: "#fff",
    },
  },
});

lightTheme = responsiveFontSizes(lightTheme);

export default lightTheme;
